import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import "./styles.scss"
import { LandingPageHead } from "./pageComponent/landingHead"
import { Trans, useTranslation } from "react-i18next"
import { Banner, LandingCTABanner } from "../Banner"
import { Divider, GenericWrapperContext, Typography } from "@cakemail-org/ui-components-v2"
import { LandingTextImg } from "./pageComponent/landingTextImg"
import { LandingCollaborations } from "./pageComponent/collaborations"
import { LandingFooter } from "./pageComponent/landingFooter"
import { LandingFeatureCards } from "./pageComponent/landingFeatureCards"
import { useContext } from "react"
import { TButtonClick } from "@cakemail-org/ui-components-v2/dist/esm/components/button/types"

export function EmailAPILandingPage({ mainCTA }: { mainCTA: Function }) {
    const genericWrapper = useContext(GenericWrapperContext)
    const { t, i18n } = useTranslation()

    function handleMainCTA(event: React.MouseEvent<HTMLButtonElement>) {
        mainCTA(event.currentTarget.name)
    }

    return <Stack className="landingPage emailAPILanding" gap={16} alignItems="center">
        <Banner
            text={t("landing-page-email-api-banner-text", { firstName: genericWrapper.user?.first_name })}
            ctaTxt={t("landing-page-email-api-banner-cta-txt")}
            cta={handleMainCTA}
        />
        <Stack className="landingPageContentContainer" gap={16} alignItems="center">
            <LandingPageHead
                support={t("landing-page-email-api-main-support")}
                title={t("landing-page-email-api-main-title")}
                features={[
                    t("landing-page-email-api-main-feature-1"),
                    t("landing-page-email-api-main-feature-2"),
                    t("landing-page-email-api-main-feature-3"),
                    t("landing-page-email-api-main-feature-4"),
                    t("landing-page-email-api-main-feature-5"),
                ]}
                imgSrc="https://storage.googleapis.com/ckm-images/cakemail/solutions/email-api/hero.png"
                addOn
                ctaTxt={t("landing-page-email-api-main-cta-txt")}
                cta={handleMainCTA}
            />

            <LandingTextImg
                reversed
                imgSrc="https://storage.googleapis.com/ckm-images/cakemail/solutions/email-api/easy-integration.png"
                support={t("landing-page-email-api-feature-1-support")}
                title={t("landing-page-email-api-feature-1-title")}
                desc={<Trans i18nKey="landing-page-email-api-feature-1-desc" />}
            />

            <Divider />

            <LandingTextImg
                imgSrc="https://storage.googleapis.com/ckm-images/cakemail/solutions/email-api/personalized-emails.png"
                support={t("landing-page-email-api-feature-2-support")}
                title={t("landing-page-email-api-feature-2-title")}
                desc={<Trans i18nKey="landing-page-email-api-feature-2-desc" />}
            />

            <Divider />

            <LandingTextImg
                reversed
                imgSrc="https://storage.googleapis.com/ckm-images/cakemail/solutions/email-api/analytics.png"
                support={t("landing-page-email-api-feature-3-support")}
                title={t("landing-page-email-api-feature-3-title")}
                desc={<Trans i18nKey="landing-page-email-api-feature-3-desc" />}
            />

            <Divider />

            <LandingCollaborations
                chipLabel={t("general-close-collaboration")}
                logo={"https://storage.googleapis.com/ckm-images/cakemail/logos/yapla.svg"}
                testimony={t("landing-page-email-api-testimony-yapla")}
                imgSrc={"https://storage.googleapis.com/ckm-images/cakemail/customers/pascal-jarry-yapla.jpg"}
                collaboratorName={t("landing-page-email-api-testimony-yapla-collaborator")}
                jobTitle={t("landing-page-email-api-testimony-yapla-job-title")}
                companyName={t("landing-page-email-api-testimony-yapla-name")}
            />
        </Stack>
        <LandingFooter
            support={t("landing-page-email-api-footer-support")}
            title={t("landing-page-email-api-footer-title")}
            desc={t("landing-page-email-api-footer-desc")}
            subDesc={t("landing-page-email-api-footer-sub-desc")}
            ctaTitle={t("landing-page-email-api-footer-cta-title", { firstName: genericWrapper.user?.first_name })}
            ctaTxt={t("landing-page-email-api-footer-cta-txt")}
            cta={handleMainCTA}
        />
    </Stack >
}